import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#6f9cff", contrastText: "#0b0f17" },
    secondary: { main: "#b18aff" },
    success: { main: "#4caf50" },
    warning: { main: "#ffa726" },
    error: { main: "#ef5350" },
    info: { main: "#4fc3f7" },
    background: {
      default: "#0e131b",
      paper: "#161d29",
    },
    text: {
      primary: "#e8eaf0",
      secondary: "#9aa5b8",
      disabled: "#5c6577",
    },
    divider: "rgba(255,255,255,0.12)",
  },
  shape: { borderRadius: 8 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { backgroundColor: "#0e131b" },
        "::-webkit-scrollbar": { width: 10, height: 10 },
        "::-webkit-scrollbar-track": { background: "#0e131b" },
        "::-webkit-scrollbar-thumb": { background: "#2a3345", borderRadius: 8 },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: "none" },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: { backgroundImage: "none" },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: { borderColor: "rgba(255,255,255,0.08)" },
        head: { color: "#c3cad9", fontWeight: 700 },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { textTransform: "none", fontWeight: 600 },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: { backgroundImage: "none", backgroundColor: "#161d29" },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& fieldset": { borderColor: "rgba(255,255,255,0.18)" },
          "&:hover fieldset": { borderColor: "rgba(255,255,255,0.32)" },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 600 },
      },
    },
  },
});

export default theme;
